import { getData } from "country-list";

const COUNTRIES = getData().map(({ code, name }) => ({
  code: String(code || "").toUpperCase(),
  name: String(name || ""),
}));

export const getFlagURIByCountryCode = (code) => {
  if (!code) {
    return;
  }

  return `https://flagcdn.com/w80/${code?.toLowerCase()}.png`;
};

export const searchCountries = async (search = "") => {
  const term = String(search || "")
    .trim()
    .toLowerCase();
  if (term.length < 2) {
    return [];
  }

  const results = COUNTRIES.filter((c) => {
    const name = c.name.toLowerCase();
    const code = c.code.toLowerCase();
    return name.includes(term) || code.includes(term);
  });

  return results.slice(0, 100);
};
